import { Link } from "react-router-dom";
import { Gift, ChevronRight } from "lucide-react";

export const ReferralCta = () => (
  <section className="py-12 sm:py-16 px-4" data-testid="referral-cta-section">
    <Link
      to="/referidos"
      className="max-w-3xl mx-auto glass-card p-6 sm:p-8 border-[#B026FF]/40 flex flex-col sm:flex-row items-center gap-5 hover:shadow-[0_0_28px_rgba(176,38,255,0.25)] hover:-translate-y-0.5 transition-all duration-300"
      data-testid="referral-cta-link"
    >
      <div className="w-16 h-16 rounded-full bg-[#B026FF]/10 flex items-center justify-center flex-shrink-0">
        <Gift className="w-8 h-8 text-[#B026FF]" />
      </div>
      <div className="flex-1 text-center sm:text-left">
        <h2 className="font-oswald text-2xl sm:text-3xl font-bold text-white uppercase tracking-wider">Comparte y Gana $50</h2>
        <p className="text-[#A0A0A0] text-base mt-1">Recomienda la tienda a tus amigos y familia. Por cada compra que hagan, te pagamos $50 MXN.</p>
      </div>
      <span className="inline-flex items-center gap-2 bg-[#B026FF] text-white px-6 py-3 rounded-full font-bold text-base uppercase tracking-wide whitespace-nowrap">
        Quiero ganar <ChevronRight className="w-4 h-4" />
      </span>
    </Link>
  </section>
);
